// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoNotReady_wrapper__PKmA7","wrappertransparent":"VideoNotReady_wrappertransparent__fHvkA","heading":"VideoNotReady_heading__vBEr8"};